import React, {useEffect, useState} from 'react';
import {DocumentDuplicateIcon, PlusCircleIcon} from "@heroicons/react/24/solid";
import ShowProductColorTags from "../common/show-product-color-tags";
import ShowDesignVariantStatus from "../common/show-design-variant-status";
import _ from 'lodash';
import DeleteDesignVariant from "./delete-design-variant";
import DesignVariantDesigner from "../designer/design-variant-designer";
import ShowDesignVariantIndex from "../common/show-design-variant-index";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import CopyDesignVariants from "./copy-design-variants";
import DownloadDesignVariants from "../download/download-design-variants";
import MultiVariantDesigner from "../multi-variant-designer/multi-variant-designer";
import ShowDesignBatchList from "../common/show-design-batch-list";
import EditBatchDesignVariants from "../multi-products-designer/edit-batch-design-variants";

const DesignVariantItemList = ({
                                   designDetail,
                                   addNewDesignVariant,
                                   handleSelectedVariant,
                                   removeDesignVariant,
                                   selectedVariant,
                                   setDesignDetail,
                                   allTags,
                                   quoteDetail,
                                   parentProduct,
                                   duplicateDesignVariant,
                                   copyDesignVariantList,
                                   updateVariantColorsInDesign,
                                   dataFetchInProgress,
                                   selectedDesignBatchId = '',
                                   setSelectedDesignBatchId = undefined
                               }) => {
    const [variantsList, setVariantsList] = useState(designDetail?.variants);
    const [designBatchesList, setDesignBatchesList] = useState([]);

    useEffect(() => {
        if (selectedDesignBatchId) {
            const variantsListByBatchMap = _.groupBy(designDetail?.variants, 'batchKey');
            setVariantsList(variantsListByBatchMap[selectedDesignBatchId]);

            console.log('variantsListByBatchMap: ', variantsListByBatchMap)
        } else {
            setVariantsList(designDetail?.variants);
        }

        prepareBatchVariantsList();
    }, [designDetail]);

    const prepareBatchVariantsList = () => {
        const tempDesignBatchesList = [];
        const variantsListByBatchMap = _.groupBy(designDetail?.variants, 'batchKey');

        _.forEach(designDetail?.batches, batch => {
            const batchDetail = _.cloneDeep(batch);
            batchDetail.variants = variantsListByBatchMap[batch.batchKey] || [];
            tempDesignBatchesList.push(batchDetail);
        });

        if (variantsListByBatchMap.hasOwnProperty('undefined')) {
            const batchDetail = {
                batchKey: 'None',
                variants: variantsListByBatchMap['undefined'] || []
            };

            tempDesignBatchesList.push(batchDetail);
        }

        setDesignBatchesList(tempDesignBatchesList);
    }

    return (
        <>

            <div className="flex justify-start items-center w-full m-2 pb-2">
                <div className="text-xl">
                    Variants
                </div>

                <div className="ml-4">
                    <div className="cursor-pointer"
                         onClick={() => {
                             addNewDesignVariant();
                         }}>
                        <div className="">
                            <PlusCircleIcon className="h-8 w-8"/>
                        </div>
                    </div>
                </div>

                <div className="ml-4">
                    <CopyDesignVariants
                        currentDesignDetail={designDetail}
                        copyDesignVariantList={copyDesignVariantList}/>
                </div>

                <div className="ml-4">
                    <DownloadDesignVariants
                        designDetail={designDetail}
                        parentProduct={parentProduct}
                        updateVariantColorsInDesign={updateVariantColorsInDesign}
                        isAssignColors={true}
                        isPreview={false}
                        isLightButton={false}
                        setDesignDetail={setDesignDetail}/>
                </div>

                <div className="ml-4">
                    <MultiVariantDesigner
                        designDetail={designDetail}
                        setDesignDetail={setDesignDetail}
                        allTags={allTags}
                        quoteDetail={quoteDetail}
                        parentProduct={parentProduct}/>
                </div>

                <div className="ml-4">
                    <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                </div>

                {/*<div className="text-right float-right flex justify-center">
                    <ShowDesignBatchList
                        designDetail={designDetail}
                        selectedDesignBatchId={selectedDesignBatchId}
                        setSelectedDesignBatchId={setSelectedDesignBatchId}
                    />
                </div>*/}
            </div>

            <div
                className="table-container overflow-y-scroll bg-blue-100 border border-gray-400 p-4">

                {designBatchesList?.map((batchDetail, index) => (

                    <React.Fragment key={index}>
                        <div className="flex justify-start items-center mb-2">
                            {batchDetail?.batchKey === 'None' &&
                                <div className="ml-3 text-lg font-bold text-gray-500">
                                    Individual Design Variants
                                </div>
                            }


                            {batchDetail?.batchKey !== 'None' &&
                                <>
                                    <div className="ml-3 text-lg font-bold text-gray-500">
                                        Design Batch {batchDetail?.batchKey}
                                    </div>

                                    <div className="ml-4">
                                        <EditBatchDesignVariants
                                            designDetail={designDetail}
                                            batchDetail={batchDetail}
                                            setDesignDetail={setDesignDetail}
                                        />
                                    </div>
                                </>
                            }
                        </div>

                        <div className="flex flex-wrap justify-start content-start mb-8">
                            {batchDetail?.variants?.map((designVariant, index) => (
                                <div key={index}
                                     className="shadow-lg bg-white text-neutral-600 hover:bg-purple-50 hover:border hover:border-purple-600 rounded m-2 h-40 w-80">

                                    <div className="px-4 pt-6">
                                        <div className="h-20 -mt-3">
                                            <div className="font-bold text-gray-700 flex justify-between text-center">
                                                <div className="mt-1">
                                                    <ShowDesignVariantIndex designVariantDetail={designVariant}/>
                                                </div>
                                                {batchDetail?.batchKey !== 'None' &&
                                                    <div className="mt-1 text-gray-400">
                                                        Batch {designVariant?.batchKey}
                                                    </div>
                                                }
                                                <ShowDesignVariantStatus designVariantDetail={designVariant}/>
                                            </div>
                                            <div className="-ml-1">
                                                {designVariant?.colors?.length > 0 &&
                                                    <ShowProductColorTags parent={designVariant}/>
                                                }

                                                {!designVariant?.colors &&
                                                    <div className="text-red-400 font-semibold ml-1">No Product
                                                        Colors</div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex justify-between px-4 py-2 mt-1">
                                        <div className="w-full mr-2">
                                            <DesignVariantDesigner
                                                updateVariantColorsInDesign={updateVariantColorsInDesign}
                                                duplicateDesignVariant={duplicateDesignVariant}
                                                allTags={allTags}
                                                designDetail={designDetail}
                                                selectedVariant={designVariant}
                                                quoteDetail={quoteDetail}
                                                parentProduct={parentProduct}
                                                setDesignDetail={setDesignDetail}/>
                                        </div>

                                        <div className="mr-2">
                                            <button onClick={() => duplicateDesignVariant(designVariant)}
                                                    className="button-outline-small">
                                                <div className="mr-1">
                                                    <DocumentDuplicateIcon className="h-6 w-6"/>
                                                </div>
                                            </button>
                                        </div>

                                        <div className="float-right">
                                            <DeleteDesignVariant
                                                designVariant={designVariant}
                                                removeDesignVariant={removeDesignVariant}/>
                                        </div>

                                    </div>

                                </div>
                            ))}
                        </div>
                    </React.Fragment>

                ))}

            </div>

        </>
    )
}

export default DesignVariantItemList
